"use client";

import React, { useMemo } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export interface TaskAISummarySkeletonProps {
  statusMessage: string;
  className?: string;
}

/**
 * Loading skeleton for task AI summary
 * Shows shimmer animation with status message
 */
export function TaskAISummarySkeleton({
  statusMessage,
  className,
}: TaskAISummarySkeletonProps) {
  const shimmerComponent = useMemo(
    () => (
      <div className="space-y-3">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>{statusMessage}</span>
        </div>
        <div className="space-y-2">
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse bg-[length:200%_100%] animate-[shimmer_2s_ease-in-out_infinite]"></div>
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse bg-[length:200%_100%] animate-[shimmer_2s_ease-in-out_infinite] w-5/6"></div>
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse bg-[length:200%_100%] animate-[shimmer_2s_ease-in-out_infinite] w-4/5"></div>
        </div>
      </div>
    ),
    [statusMessage]
  );

  return <div className={cn("space-y-3", className)}>{shimmerComponent}</div>;
}
